import request from "@/utils/request";

// 查询招商信息列表
export async function landList(data) {
  return request({
    url: "/parcel-cms/parcel/getPage",
    method: "post",
    data: data,
  });
}

// 查询招商信息列表-信息填报-需要登录
export async function landListLogin(data) {
  return request({
    url: "/parcel-cms/parcel/getPageLogin",
    method: "post",
    data: data,
  });
}

export async function addLand(data) {
  return request({
    url: "/parcel-cms/parcel/add",
    method: "post",
    data: data,
  });
}

export async function infoList(data) {
  return request({
    url: "/parcel-cms/park/getPage",
    method: "post",
    data: data,
  });
}

export async function infoDel(id) {
  return request({
    url: "/parcel-cms/park/delete/" + id,
    method: "post",
  });
}

export async function landDel(id) {
  return request({
    url: "/parcel-cms/parcel/delete/" + id,
    method: "post",
  });
}

export async function addInfo(data) {
  return request({
    url: "/parcel-cms/park/add",
    method: "post",
    data: data,
  });
}

export async function fileUpload(data) {
  return request({
    url: "/file-system/file/manage/upload2",
    method: "post",
    data: data,
  });
}

export async function updateLand(data) {
  return request({
    url: "/parcel-cms/parcel/update",
    method: "post",
    data: data,
  });
}

export async function updateInfo(data) {
  return request({
    url: "/parcel-cms/park/update",
    method: "post",
    data: data,
  });
}

export async function getLandInfoTwo(id) {
  return request({
    url: "/parcel-cms/parcel/getTwo/" + id,
    method: "get",
  });
}

export async function getLandInfo(id) {
  return request({
    url: "/parcel-cms/parcel/getOne/" + id,
    method: "get",
  });
}
export async function getLandInfoLogin(id) {
  return request({
    url: "/parcel-cms/parcel/getOneLogin/" + id,
    method: "get",
  });
}

export async function approvalLand(data) {
  return request({
    url: "/parcel-cms/parcel/updateApproval",
    method: "post",
    data: data,
  });
}

//实际范围分页查询
export async function getActualPage(data) {
  return request({
    url: "/parcel-cms/parkActual/getPage",
    method: "post",
    data: data,
  });
}

//园区列表数组查询-分页
export async function getParkPage(data) {
  return request({
    url: "/parcel-cms/park/getPageComplete",
    method: "post",
    data: data,
  });
}

//园区列表数组查询-不分页
export async function getParkList(data) {
  return request({
    url: "/parcel-cms/park/get-list",
    method: "post",
    data: data,
  });
}
//园区列表数组查询-不分页
export async function getParkIndexList(data) {
  return request({
    url: "/parcel-cms/park/index-list",
    method: "post",
    data: data,
  });
}

//园区列表数组查询-不分页
export async function getParkListPage(data) {
  return request({
    url: "/parcel-cms/park/park-list",
    method: "get",
  });
}




//行政区招商信息分页查询
export async function getAttractList(data) {
  return request({
    url: "/parcel-cms/attract/getPage",
    method: "post",
    data: data,
  });
}


//公告列表数组查询
export async function getNoticeList(data) {
  return request({
    url: "/parcel-cms/notice/get-list",
    method: "post",
    data: data,
  });
}

//公告列表数组查询-分页
export async function getNoticePage(data) {
  return request({
    url: "/parcel-cms/notice/getPage",
    method: "post",
    data: data,
  });
}

//行政区招商信息分页查询-需登录
export async function getAttractListLogin(data) {
  return request({
    url: "/parcel-cms/attract/getPageLogin",
    method: "post",
    data: data,
  });
}

//行政区招商信息新增
export async function addAttractInfo(data) {
  return request({
    url: "/parcel-cms/attract/add",
    method: "post",
    data: data,
  });
}

//行政区招商信息根据id查询详细

export async function getAttractInfo(id) {
  return request({
    url: "/parcel-cms/attract/getOne/" + id,
    method: "get",
  });
}

//行政区招商信息根据主键更新
export async function updateAttractInfo(data) {
  return request({
    url: "/parcel-cms/attract/update",
    method: "post",
    data: data,
  });
}

//行政区招商信息根据主键删除
export async function delAttractInfo(id) {
  return request({
    url: "/parcel-cms/attract/delete/" + id,
    method: "post",
  });
}

//用地需求新增
export async function addRequirement(data) {
  return request({
    url: "/parcel-cms/requirement/add",
    method: "post",
    data: data,
  });
}

//用地需求删除
export async function delRequirement(id) {
  return request({
    url: "/parcel-cms/requirement/delete/" + id,
    method: "post",
  });
}

//用地需求根据id查询详细

export async function getRequirement(id) {
  return request({
    url: "/parcel-cms/requirement/getOne/" + id,
    method: "get",
  });
}

//用地需求分页查询
export async function getRequirementList(data) {
  return request({
    url: "/parcel-cms/requirement/getPage",
    method: "post",
    data: data,
  });
}

// 地块类型，面积统计
export async function statisticalParcelStatus(data) {
  return request({
    url: "/parcel-cms/dict/getParcelStatusStatistical",
    method: "post",
    data: data,
  });
}

//用户查行政区划
export async function getXzDms() {
  return request({
    url: "/parcel-cms/parcel/getXzDms",
    method: "post",
  });
}

//根据id查询详细 不登录
export async function getParkDetail(id) {
  return request({
    url: "/parcel-cms/park/getOne/" + id,
    method: "get",
  });
}

//获取园区管理地块列表
export async function getParkLandList(parkCode) {
  return request({
    url: "/parcel-cms/parcel/parkCode/" + parkCode,
    method: "get",
  });
}

//获取园区管理地块列表
export async function searchKey(data) {
  return request({
    url: "/parcel-cms/search/keyName",
    method: "get",
    params:data
  });
}

//统计交易状态地块数量
export async function getTransactionInfo(data) {
  return request({
    url: "/parcel-cms/dict/getTransactionParcelInfoStatistical",
    method: "post",
    data:data
  });
}


//根据id获取文件图片信息
export async function getPicture(data) {
  return request({
    url: "/parcel-cms/parcel/picture/"+data,
    method: "get",
  });
}

//根据id获取图形位置信息
export async function getShp(data) {
  return request({
    url: "/parcel-cms/parcel/shp/"+data,
    method: "get",
  });
}


//获取标签信息列表，type:0系统标签,1自定义标签
export async function getLabelList(data) {
  return request({
    url: "/parcel-cms/label/tree",
    method: "get",
    params:data,
  });
}



//根据行政区划获取已发布园区列表下拉框
export function getXzqhParkList(divisionCode) {
  return request({
      url: '/parcel-cms/park/park-list/'+divisionCode,
      method: 'get',
  })
}


//根据名称模糊查询行政区划
export function getAdministrative(data) {
  return request({
      url: '/parcel-cms/dict/getAdministrative',
      method: 'post',
      params:data
  })
}

//根据行政区划、及园区名获取园区列表
export function getCountyParkList(data) {
  return request({
      url: '/parcel-cms/park/park-list',
      method: 'post',
      params:data
  })
}



//发送短信,获取是否发送验证的状态
export function getPhoneCode(data) {
  return request({
      url: '/parcel-cms/note/code',
      method: 'post',
      params:data
  })
}
//图上选地地块、园区统计
// export function getParcelCms() {
//   return request({
//     url: '/parcel-cms/parcel/tsxd',
//     method: 'get'
//   })
// }


//首次默认返回几条园区地块信息 type:0园区,1:地块
export function searchDefault(data) {
  return request({
    url: '/parcel-cms/search/default',
    method: 'get',
    params:data
  })
}

//通过code查询园区详情
export function searchParkInfo(data) {
  return request({
    url: '/parcel-cms/park/park-info',
    method: 'get',
    params:data
  })
}

export async function getChunkCenterList(data) {
  return request({
    url: "/parcel-cms/parcel/center-point/all"  ,
    method: "get",
    params:data
  });
}

export async function getAllShpByScope(data) {
  return request({
    url: "/parcel-cms/parcel/shp/getAllShpByScope",
    method: "post",
	data:data
  });
}

export async function getSupplyPeriod(data) {
  return request({
    url: "/parcel-cms/parcel/supply-period",
    method: "post",
    data:data
  });
}
export async function getSupplyPeriodIndex(data) {
  return request({
    url: "/parcel-cms/parcel/supply-period-index",
    method: "get",
    params:data
  });
}
// 获取地价
export async function landPriceData(data) {
  return request({
    url: "/parcel-cms/parcel/land-price",
    method: "post",
    params:data
  });
}

// 获取招商政策
export async function policyInfo(data) {
  return request({
    url: "/parcel-cms/manage/policy/info",
    method: "post",
    params:data
  });
}

// 出让公告 宗地编号
export async function transferAnnouncement(code){
  return request({
    url: "/parcel-cms/transfer-announcement/code",
    method: "post",
    params:{code:code}
  });
}
// 出让公示 宗地编号
export async function plotPublicity(code){
  return request({
    url: "/parcel-cms/plot-publicity/code",
    method: "post",
    params:{code:code}
  });
}

//获取热门推荐-分页
export async function hotLandList(data){
  return request({
    url: "/parcel-cms/parcel/index-page",
    method: "post",
    data:data
  });
}

//获取招商政策列表
export async function getPolicyPage(data) {
  return request({
      url: 'parcel-cms/manage/policy/page',
      method: "post",
      data:data
  });
}

//出让公告及成交公示
export async function getTransferAnnouncementPage(data) {
  return request({
      url: '/parcel-cms/transfer-announcement/all-page',
      method: "post",
      data:data
  });
}


//根据项目id查询可供地块列表-精准推荐
export async function projectParcelList(id) {
  return request({
      url: '/parcel-cms/project/parcel-list/'+id,
      method: "get",
  });
}

//查询项目详情-根据项目id匹配地块-指定关联的地块数据
export async function projectNearlList(id) {
  return request({
      url: '/parcel-cms/project/parcel-near-list/'+id,
      method: "get",
  });
}

//查询项目详情-根据项目id匹配地块-精准匹配
export async function projectlandList(id) {
  return request({
      url: '/parcel-cms/project/parcel-login-list/'+id,
      method: "get",
  });
}

//添加地块到收藏夹
export async function addFavorite(data) {
  return request({
      url: '/parcel-cms/favorite/add',
      method: "post",
      params:data
  });
}

//获取当前用户收藏夹分页列表
export async function infoFavoriteList(data) {
  return request({
      url: '/parcel-cms/favorite/info',
      method: "post",
      data:data
  });
}

//取消收藏
export async function cancelFavoriteList(id) {
  return request({
      url: '/parcel-cms/favorite/cancel/'+id,
      method: "get",
  });
}

//查询当前地块是否已收藏
export async function confirmFavorite(id) {
  return request({
      url: '/parcel-cms/favorite/confirm/'+id,
      method: "get",
  });
}

//成交公示
export async function plotPublicityPage(data) {
  return request({
      url: '/parcel-cms/plot-publicity/page-not-login',
      method: "post",
      data:data
  });
}
//出让公告
export async function transferAnnouncementList(data) {
  return request({
      url: '/parcel-cms/transfer-announcement/page-not-login',
      method: "post",
      data:data
  });
}


// 根据id获取招商项目的图形信息
export async function getProjectShp(id){
  return request({
    url: "/parcel-cms/project/shp/"+id,
    method: "get",
  });
}
// 根据园区级别获取园区信息,level:1->3 国家级、省级、其他
export async function getLevePark(code){
  return request({
    url:`/parcel-cms/park/park-level-list?level=${code}` ,
    method:"get",
  })
}

//根据行政区划判断是否有行政区划信息
export async function attractConfirm(data){
  return request({
    url:'/parcel-cms/attract/confirm' ,
    method:"post",
    data:data
  })
}

//搜索用地点
export async function getParcelAll(data){
  return request({
    url:'/parcel-cms/parcel/ysxd-center-point/all' ,
    method:"post",
    data:data
  })
}

//获取所有园区中心点
export async function parkCenterPoint() {
  return request({
    url: "/parcel-cms/park/center-point",
    method: "post",
  });
}

// 批量取消意向地块
export async function  DKcancelAll(data){
  return request({
    url:"/parcel-cms/favorite/cancel-batch",
    method:'post',
    data:data
  })
}


//根据视图范围获取园区图形信息
export async function parkAllShp(data) {
  return request({
    url: "/parcel-cms/leader-cockpit/park/getAllShpByScope",
    method: "post",
    data:data
  });
}
//根据视图范围获取园区图形信息未上架
export async function getParkAllShp(data) {
  return request({
    url: "/parcel-cms/park/getAllShpByScope",
    method: "post",
    data:data
  });
}

//园区图形
export async function getParkShp(id) {
  return request({
    url: "/parcel-cms/park/shp/" + id,
    method: "get",
  });
}
//根据code园区图形
export async function getParkCodeShp(code) {
  return request({
    url: "/parcel-cms/park/shp-code/" + code,
    method: "get",
  });
}

//根据行政区划code查询下一级行政区划范围
export async function getCountyChildShp(data) {
  return request({
    url: "/parcel-cms/dict/child/shp",
    method: "post",
    data:data
  });
}


//根据行政区划code查询下一级行政区划范围
export async function getQxShpByScope(data) {
  return request({
    url: "/parcel-cms/dict/shp/getAllShpByScope",
    method: "post",
    data:data
  });
}


//行业父级列表查询
export async function getIndustryList() {
  return request({
    url: "/parcel-cms/dict/industry",
    method: "get",
  });
}
//根据推介专场id与地块外层id查询地块列表
export async function getInnerParcelList(data) {
  return request({
    url: "/parcel-cms/special-promotion/new/inner-parcel",
    method: "post",
    data:data
  });
}

//根据获取用地列表
export async function getParcelIndex(data) {
  return request({
    url: "/parcel-cms/parcel/index",
    method: "post",
    data:data
  });
}

//根据推介专场id获取所有地块点范围
export async function getPromotionParcel(id) {
  return request({
    url: "/parcel-cms/special-promotion/new/parcel-shp/"+id,
    method: "get",
  });
}
//根据推介专场id及可视范围查询所有地块范围
export async function getPromotionScope(data) {
  return request({
    url: "/parcel-cms/special-promotion/new/parcel-scope",
    method: "post",
    data:data
  });
}

//项目对应的工矿仓储地块
export async function getParcelRange(data) {
  return request({
    url: "/parcel-cms/project/parcel-range",
    method: "post",
    data:data
  });
}

//根据地块显示shp交叉园区
export async function getParkRange(id) {
  return request({
    url: "/parcel-cms/park/park-scope/"+id,
    method: "get",
  });
}
// 主页 出让公告、地块公示5条
export async function getIndexAnnouncement(){
  return request ({
     url:"/parcel-cms/parcel/index-announce",
     method:"get"
  })
}
// 首页公告详情
export  async function getIndexAnnouncementDetails(data){
   return request({
     url:"/parcel-cms/plot-publicity/code",
     method:"post",
     params:data
   })
}

//根据id获取图形位置信息
export  async function getPewgShp(id){
  return request({
    url:"/parcel-cms/project/pewg/"+id,
    method:"get",
  })
}

//获取项目工矿土地规划可用总面积
export  async function getPewgParcelArea(id){
  return request({
    url:"/parcel-cms/project/parcel-area/"+id,
    method:"get",
  })
}
//项目招商获取视图范围内的地块面
export  async function getAllShpProjectByScope(data){
  return request({
    url:"/parcel-cms/project/shp/getAllShpByScope",
    method:"post",
    data:data
  })
}

//
export  async function statisticsAdd(data){
  return request({
    url:"/parcel-cms/view-statistics/add",
    method:"get",
  })
}
